import { normalizeFilterValue } from '../../shared/controleDescargaMapper';

const DESCARGA_COLUNAS_SEMPRE_VISIVEIS = [];
const DESCARGA_COLUNAS_NAO_EXPORTAVEIS = ['localizacao', 'acoes'];

const DESCARGA_COLUNAS_PADRAO_VISIVEIS = [
  'localizacao',
  'acoes',
  'numeroCarga',
  'cargasCTE',
  'loja',
  'lojaRemetente',
  'cidade',
  'descricaoPosicaoAngellira',
  'numeroFrota',
  'tipoVeiculo',
  'frotasReboque',
  'quantidadePaletes',
  'descricaoTipoOperacao',
  'nomeResponsavel',
  'dataAgendamentoDescarga',
  'chegadaDescarga',
  'saidaDescarga',
  'tempoEsperaDescarga',
  'inicioContagem',
  'tempoForaJanela',
  'janelaAplicada',
  'tempoAtrasado',
  'clienteDistanciaAngellira',
  'clienteTempoPrevChegadaAngellira'
];

const DESCARGA_TODAS_COLUNAS_IDS = [
  'numeroCarga',
  'cargasCTE',
  'protocoloCarga',
  'codigoCarga',
  'situacaoCarga',
  'descricaoTipoOperacao',
  'numeroPedido',
  'protocoloPedido',
  'codigoPedido',
  'dataAgendamentoPedido',
  'quantidadePaletes',
  'placaVeiculo',
  'numeroFrota',
  'tipoVeiculo',
  'descricaoModeloVeicular',
  'nomeRemetente',
  'cnpjRemetente',
  'nomeDestinatario',
  'cnpjDestinatario',
  'loja',
  'lojaRemetente',
  'cidade',
  'ufDestinatario',
  'nomeTomador',
  'cnpjTomador',
  'placasReboque',
  'frotasReboque',
  'modelosReboque',
  'dataCriacaoPedido',
  'dataCriacaoCarga',
  'dataCarregamentoPedido',
  'infoMotorista',
  'nomeResponsavel',
  'dataAgendamentoDescarga',
  'chegadaDescarga',
  'saidaDescarga',
  'tempoEsperaDescarga',
  'inicioContagem',
  'tempoForaJanela',
  'janelaAplicada',
  'tempoAtrasado',
  'observacoesDescarga',
  'descricaoPosicaoAngellira',
  'codigoViagemAngellira',
  'statusViagemAngellira',
  'clienteDistanciaAngellira',
  'clienteTempoPrevChegadaAngellira',
  'acoes',
  'localizacao'
];

export const listagemConfig = {
  rotaListagem: '/pages/descarga/descargas',
  columnConfigKey: 'descargas-controle-columns-v11',
  colunas: {
    todasIds: DESCARGA_TODAS_COLUNAS_IDS,
    sempreVisiveis: DESCARGA_COLUNAS_SEMPRE_VISIVEIS,
    padraoVisiveis: DESCARGA_COLUNAS_PADRAO_VISIVEIS,
    naoExportaveis: DESCARGA_COLUNAS_NAO_EXPORTAVEIS
  },
  normalizeFilterValue
};

const filterNaoExportaveis = (columnIds, naoExportaveis) => (
  columnIds.filter((columnId) => !naoExportaveis.includes(columnId))
);

export const buildListagemExportConfig = (config) => {
  const naoExportaveis = config.colunas.naoExportaveis || [];

  return {
    columnConfigKey: config.columnConfigKey,
    padraoVisiveis: filterNaoExportaveis(config.colunas.padraoVisiveis, naoExportaveis),
    todasIds: filterNaoExportaveis(config.colunas.todasIds, naoExportaveis),
    naoExportaveis
  };
};
